<template>
	<div class="site-search-resource-card-container">
    <a :href="`/${$filters.convertResourceType(result['type'])}/${result['slug']}`" @click="save_search">
		  
      <div class="site-search-resource-card">

        <div class="site-search-resource-card__logo-container">
          <img class="site-search-resource-card__logo" :src="$filters.analyseImage(result['cover-image'],'herosearchxs','herosearchsm')" width="54" height="54" alt="" loading="lazy">
        </div>

        <h4 class="site-search-resource-card__title">{{ result['title'] }}</h4>

        <div class="site-search-resource-card__tablet-group">
          <span class="site-search-resource-card__tablet">?</span>
          <span class="site-search-resource-card__tablet">?</span>
        </div>

        <svg-chevron-left></svg-chevron-left>
      </div>

    </a>
	</div>
</template>

<script>
export default {
  props: {
    result: {
      type: [Object],
      default: {}
    }
  },

  data() {
    return {

    }
  },

	mounted() {
		// console.log('site search resource', this.result);
	},

  methods: {
		save_search() {
			this.$emit('save:search');
		}
  }
}
</script>
